module.exports = __webpack_public_path__ + "images/6cfc444cb4cd69509d41ae2a61311896-hotel.png";